import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  output,
} from '@angular/core';
import { DatePipe } from '@angular/common';
import { Address } from '../../types/address';

import {
  TranslatePipe,
  IconComponent,
  ButtonComponent,
  CardComponent,
  CardHeaderComponent,
  CardBodyComponent,
  CardTitleComponent,
  SoftSlotDirective,
  MessageBarService,
} from '@softline/ui-core';
import { Auslieferungsstatus, Palette } from '../../types/palette';
import { PalettenModus } from '../../types/delivery-note';
@Component({
  selector: 'soft-delivery-note-address-card',
  imports: [
    TranslatePipe,
    IconComponent,
    ButtonComponent,
    DatePipe,
    CardComponent,
    CardHeaderComponent,
    CardBodyComponent,
    CardTitleComponent,
    SoftSlotDirective,
  ],
  templateUrl: './delivery-note-address-card.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeliveryNoteAddressCardComponent {
  private GOOGLE_LINK = 'https://www.google.com/maps/search/?api=1&query=';

  private readonly messageBar = inject(MessageBarService);

  readonly address = input<Address | undefined>(undefined);
  readonly headerText = input<string>('');

  readonly lieferdatum = input<string>('Kein Datum hinterlegt.');
  readonly paletten = input<Palette[]>([]);
  readonly palettenModus = input<PalettenModus>();
  readonly fotoClicked = output<void>();

  protected readonly PalettenModus = PalettenModus;

  openNavigation(): void {
    window.open(this.generateMapsLink(this.address()), '_blank', 'noopener,noreferrer');
  }

  openPhone(): void {
    const tel = this.address()?.telefon;
    if (tel) {
      window.location.href = 'tel:' + tel;
    } else {
      this.messageBar.error('Keine Telefonnummer hinterlegt.');
    }
  }

  generateMapsLink(address: Address | undefined): string {
    if (!address) return '';

    let link = this.GOOGLE_LINK;

    if (address?.geodaten?.gpsbreite && address?.geodaten?.gpslaenge) {
      link += address?.geodaten?.gpsbreite + ',' + address?.geodaten?.gpslaenge;
      return encodeURI(link);
    }

    let destination = '';

    if (address?.strasse) destination += encodeURIComponent(address?.strasse);
    if (address?.plz)
      destination += encodeURIComponent(
        destination?.length > 0 ? ', ' + address?.plz : address?.plz
      );
    if (address?.ort)
      destination += encodeURIComponent(
        destination?.length > 0 ? ' ' + address?.ort : address?.ort
      );

    return `https://www.google.com/maps/dir/?api=1&destination=${destination}`;
  }

  protected readonly numOfErledigtPaletten = computed(() => {
    const paletten = this.paletten();
    const modus = this.palettenModus();
    if (!paletten || !modus) return;
    switch (modus) {
      case PalettenModus.Erledigt:
        return paletten.length;
      case PalettenModus.Beladen:
        return paletten.filter(
          (p) => p.auslieferungsstatus === Auslieferungsstatus.Beladen
        ).length;
      case PalettenModus.Entladen:
        return paletten.filter(
          (p) => p.auslieferungsstatus === Auslieferungsstatus.Entladen
        ).length;
      default:
        return 0;
    }
  });
}
